export function isTouchDevice() {
  if (typeof window !== 'undefined') {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      //@ts-ignore
      navigator.msMaxTouchPoints > 0
    );
  }
  return false;
}

export const isDevelopment = () => {
  return process.env.NEXT_PUBLIC_APP_ENV === 'dev';
};

export const isProduction = () => {
  return process.env.NEXT_PUBLIC_APP_ENV === 'prod';
};

export const isLocal = () => {
  return process.env.NEXT_PUBLIC_APP_LOCAL === 'true';
};

export const isPR = () => {
  return process.env.NEXT_PUBLIC_APP_ENV === 'pr';
};

export const isPrBranch = () => {
  return (
    process.env.NEXT_PUBLIC_APP_ENV === 'pr' &&
    typeof window !== 'undefined' &&
    window.location?.href?.includes('-pr.preview.curipod.org')
  );
};

export const getEnvironmentLabel = () => {
  if (isLocal()) {
    return 'local';
  }

  if (isProduction()) {
    return 'production';
  }

  if (isDevelopment()) {
    return 'development';
  }

  if (isPrBranch()) {
    const locationHref = window.location?.href;
    if (!locationHref) {
      throw new Error('No href in location');
    }

    const hostname = new URL(locationHref).hostname;
    const match = hostname.match(/^([a-z0-9]+)-pr\./i);

    // We'll default to production if this doesn't work
    return match && typeof match[1] === 'string' ? match[1] : 'production';
  }
};

export const getBaseUrl = () => process.env.NEXT_PUBLIC_BASE_URL as string;
export const getBaseCoreAPIUrl = () =>
  process.env.NEXT_PUBLIC_BASE_CORE_API_URL as string;

export const generateRedirectPayload = (existingState: string, from: string) =>
  `${existingState}|redirectStart${from}redirectEnd`;
